export default __webpack_public_path__ + "static/media/050_brake_good.2b560e46.mp3";